import React from 'react';

export const DropzoneActive = ({ classNames }) => {
  return (
    <svg className={classNames || ''} width="146" height="192" viewBox="0 0 146 192" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="dropzone-active" d="M73 189C54 189 36.48 182.65 23.62 171.11C10.32 159.18 3 142.45 3 124C3 95 30.53 60 52.64 31.95C59.48 23.27 65.93 15.07 70.52 8.32001L73.07 4.56L75.52 8.38C80.29 15.79 87.46 24.95 95.05 34.65C116.41 61.94 143.05 95.91 143.05 124C143.05 142.45 135.73 159.18 122.43 171.11C109.52 182.65 92 189 73 189Z" fill="#0072B2" stroke="white" strokeWidth="4.5" strokeMiterlimit="10"/>
    </svg>
  );
};